var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565C65",
    fillRule: "evenodd",
    d: "M57.042 1.15l5.809 5.808a4 4 0 010 5.657L43.465 32l19.386 19.385a4 4 0 010 5.657l-5.809 5.809a4 4 0 01-5.657 0L32 43.465 12.615 62.851a4 4 0 01-5.657 0l-5.809-5.809a4 4 0 010-5.657L20.535 32 1.149 12.615a4 4 0 010-5.657l5.809-5.809a4 4 0 015.657 0L32 20.535 51.385 1.149a4 4 0 015.657 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9a6479b922d27bb60c3d1cb9de624341.svg";
export { ForwardRef as ReactComponent };